// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\"><defs/><path d=\"M17.74 16.34a6.5 6.5 0 10-1.4 1.4l.1.12 3.85 3.85a1 1 0 001.42-1.42l-3.85-3.85a1 1 0 00-.12-.1zM18 12.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z\"/></svg> ";
// Exports
module.exports = code;